export default function VisualMindLogoSvg() {
  return (
    <svg
      className="fill-current"
      fill="current"
      height="41"
      viewBox="0 0 32 41"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9648 13.0039C17.9592 13.0052 16.9952 13.4052 16.2842 14.1162C15.5732 14.8273 15.1732 15.7913 15.1719 16.7968V22.7571H16.2556V16.7968C16.2564 16.0785 16.5421 15.3899 17.05 14.882C17.5579 14.3742 18.2465 14.0885 18.9648 14.0876H19.5066V13.0039H18.9648Z"
        fill="current"
      />
      <path
        d="M12.463 13.0039C13.4685 13.0052 14.4325 13.4052 15.1435 14.1162C15.8545 14.8273 16.2546 15.7913 16.2559 16.7968V22.7571H15.1722V16.7968C15.1713 16.0785 14.8856 15.3899 14.3777 14.882C13.8698 14.3742 13.1812 14.0885 12.463 14.0876H11.9211V13.0039H12.463Z"
        fill="current"
      />
      <path
        d="M3.25471 28.1757C3.23111 28.5815 3.31976 28.9861 3.51092 29.3449C3.70208 29.7037 3.98837 30.0029 4.33839 30.2098V26.1416C3.98837 26.3484 3.70208 26.6477 3.51092 27.0065C3.31976 27.3653 3.23111 27.7698 3.25471 28.1757Z"
        fill="current"
      />
      <path
        d="M27.0957 26.1416V30.2098C27.4457 30.0029 27.732 29.7037 27.9232 29.3449C28.1143 28.9861 28.203 28.5815 28.1794 28.1757C28.203 27.7698 28.1143 27.3653 27.9232 27.0065C27.732 26.6477 27.4457 26.3484 27.0957 26.1416Z"
        fill="current"
      />
      <path
        d="M17.3424 20.0752V21.6736C17.3424 21.8173 17.2853 21.9552 17.1837 22.0568C17.0821 22.1584 16.9443 22.2155 16.8006 22.2155H14.6332C14.4895 22.2155 14.3517 22.1584 14.25 22.0568C14.1484 21.9552 14.0913 21.8173 14.0913 21.6736V20.0752C8.45944 20.2442 5.63265 21.2131 5.42188 21.6942V21.7045C5.67871 22.2464 9.32314 23.2992 15.7169 23.2992C22.1306 23.2992 25.7762 22.2404 26.0157 21.6476C25.8217 21.2174 22.9933 20.2448 17.3424 20.0752Z"
        fill="current"
      />
      <path
        d="M5.42188 22.9531V30.3428C5.42188 33.0732 6.50652 35.6917 8.43721 37.6224C10.3679 39.5531 12.9865 40.6378 15.7169 40.6378C18.4473 40.6378 21.0658 39.5531 22.9965 37.6224C24.9272 35.6917 26.0119 33.0732 26.0119 30.3428V22.9531C23.2436 24.3614 16.0913 24.3825 15.7169 24.3825C15.3425 24.3825 8.19014 24.3614 5.42188 22.9531ZM13.5332 28.3065C13.5072 28.4122 12.8657 30.8846 10.8403 30.8846C8.81489 30.8846 8.17335 28.4122 8.14734 28.3065C8.11235 28.1671 8.13416 28.0195 8.20799 27.8962C8.28181 27.7729 8.40159 27.684 8.54099 27.649C8.68038 27.614 8.82797 27.6358 8.95128 27.7096C9.07459 27.7835 9.16352 27.9033 9.19851 28.0426C9.20285 28.06 9.66124 29.8009 10.8403 29.8009C12.0193 29.8009 12.4777 28.06 12.4821 28.0426C12.5171 27.9033 12.606 27.7835 12.7293 27.7096C12.8526 27.6358 13.0002 27.614 13.1396 27.649C13.279 27.684 13.3988 27.7729 13.4726 27.8962C13.5464 28.0195 13.5682 28.1671 13.5332 28.3065ZM18.295 27.6498C18.4341 27.615 18.5814 27.6368 18.7045 27.7105C18.8276 27.7841 18.9165 27.9036 18.9517 28.0426C18.956 28.06 19.4144 29.8009 20.5934 29.8009C21.7725 29.8009 22.2309 28.06 22.2352 28.0426C22.2702 27.9033 22.3591 27.7835 22.4825 27.7096C22.6058 27.6358 22.7534 27.614 22.8927 27.649C23.0321 27.684 23.1519 27.7729 23.2258 27.8962C23.2996 28.0195 23.3214 28.1671 23.2864 28.3065C23.2604 28.4122 22.6188 30.8846 20.5934 30.8846C18.568 30.8846 17.9265 28.4122 17.9005 28.3065C17.8658 28.1671 17.8878 28.0196 17.9618 27.8965C18.0357 27.7734 18.1556 27.6846 18.295 27.6498ZM16.2425 29.3902L15.3755 32.8493L16.6673 32.5242C16.7369 32.5051 16.8097 32.5001 16.8812 32.5096C16.9528 32.519 17.0218 32.5426 17.0842 32.5791C17.1465 32.6155 17.2009 32.6641 17.2442 32.7219C17.2875 32.7797 17.3188 32.8455 17.3363 32.9156C17.3538 32.9857 17.3571 33.0585 17.346 33.1299C17.3349 33.2012 17.3097 33.2697 17.2718 33.3311C17.2339 33.3926 17.1841 33.4459 17.1253 33.4878C17.0665 33.5298 17 33.5595 16.9295 33.5754L14.7621 34.1172C14.6714 34.1398 14.5764 34.1386 14.4863 34.1136C14.3963 34.0886 14.3142 34.0407 14.2481 33.9746C14.182 33.9085 14.1341 33.8264 14.1091 33.7363C14.0841 33.6462 14.0828 33.5512 14.1054 33.4605L15.1891 29.1258C15.205 29.0553 15.2347 28.9888 15.2767 28.93C15.3186 28.8712 15.3719 28.8214 15.4334 28.7835C15.4948 28.7456 15.5633 28.7204 15.6346 28.7093C15.706 28.6982 15.7788 28.7015 15.8489 28.719C15.919 28.7365 15.9848 28.7678 16.0426 28.8111C16.1004 28.8544 16.149 28.9088 16.1854 28.9711C16.2219 29.0335 16.2455 29.1025 16.2549 29.174C16.2644 29.2456 16.2594 29.3184 16.2403 29.388L16.2425 29.3902Z"
        fill="current"
      />
      <rect
        fill="current"
        height="9.21131"
        width="1.08368"
        x="15.1719"
        y="6.50195"
      />
      <rect
        fill="current"
        height="3.79289"
        transform="rotate(90 11.9209 13.0049)"
        width="1.08368"
        x="11.9209"
        y="13.0049"
      />
      <rect
        fill="current"
        height="3.79289"
        transform="rotate(90 23.2988 13.0049)"
        width="1.08368"
        x="23.2988"
        y="13.0049"
      />
      <rect
        fill="current"
        height="8.12763"
        rx="4.06381"
        width="8.12763"
        x="23.2988"
        y="9.21094"
      />
      <rect
        fill="current"
        height="8.12763"
        rx="4.06381"
        width="8.12763"
        x="11.6494"
      />
      <rect
        fill="current"
        height="8.12763"
        rx="4.06381"
        width="8.12763"
        y="9.21094"
      />
    </svg>
  );
}
